import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { AnalyticsBreakdownRow } from "@/types/analytics";

type TopMetricsTableType = "revenue" | "conversions";

interface TopMetricsTableProps {
  title: string;
  data: AnalyticsBreakdownRow[];
  type: TopMetricsTableType;
}

export const TopMetricsTable = ({ title, data, type }: TopMetricsTableProps) => {
  const valueHeader = type === "revenue" ? "Rev" : "Conv.";

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead className="text-right">Clicks</TableHead>
              <TableHead className="text-right">{valueHeader}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data?.map((row, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium truncate max-w-[150px]">
                  {row.name}
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.clicks}
                </TableCell>
                <TableCell
                  className={`text-right tabular-nums ${
                    type === "revenue"
                      ? "font-medium text-[var(--chart-4-fg)]"
                      : "text-[var(--chart-3-fg)]"
                  }`}
                >
                  {type === "revenue"
                    ? `€${row.revenue?.toFixed(2) || "0.00"}`
                    : row.conversions}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

